import CurrencyNumber from "app/components/CurrencyNumber/CurrencyNumber";
import { IconCheck, IconClose } from "app/components/Icon/Icon";
import React, { useEffect, useState } from "react";
import { FormattedMessage } from "react-intl";
import * as fundingAPI from "../../../../../../api/fundingApi";

//
function ManageFundingAccountInfo(
  props: Record<string, any>
): React.ReactElement<React.ComponentProps<"div">, "div"> {
  const getFetchMonthlyTurnover = async () => {
    fundingAPI
      .fetchMonthlyTurnover()
      .then(resp => setMonthlyTurnover(resp.monthlyTurnover));
  };
  const [monthlyTurnover, setMonthlyTurnover] = useState(0);

  useEffect(() => {
    getFetchMonthlyTurnover();
  }, []);
  return (
    <div className="manage-funding__content__account-info">
      <div className="account-info__item">
        <span>
          <FormattedMessage tagName="span" id="cashier-month-turnover" />*
        </span>
        <CurrencyNumber value={monthlyTurnover} />
      </div>
      <div className="account-info__item">
        <span>
          <FormattedMessage tagName="span" id="settings-verification-status" />
        </span>
        <div className="account-info__item__status">
          {props.user["verifiedStatus"] ? (
            <span className="account-info__item__status--verified">
              <FormattedMessage tagName="span" id="settings-account-verified" />{" "}
              <IconCheck currentColor={true} />
            </span>
          ) : (
            <div>
              <span className="account-info__item__status--unverified">
                <FormattedMessage
                  tagName="span"
                  id="settings-account-unverified"
                />
                <IconClose currentColor={true} />
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ManageFundingAccountInfo;
